var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6847 6.94679e-05C10.5182 0 10.3486 0 10.176 0C5.37898 0 2.98049 0 1.49024 1.49024C1.51634e-07 2.98049 0 5.37898 0 10.176V15.264C0 20.061 1.51634e-07 22.4596 1.49024 23.9497C2.98049 25.44 5.37898 25.44 10.176 25.44C14.973 25.44 17.3716 25.44 18.8617 23.9497C20.352 22.4596 20.352 20.061 20.352 15.264V10.176C20.352 10.0033 20.352 9.83374 20.3519 9.6672H18.3167C18.3168 9.8328 18.3168 10.0024 18.3168 10.176V15.264C18.3168 17.7201 18.3125 19.3573 18.1486 20.5757C17.9927 21.7356 17.7266 22.2067 17.4227 22.5107C17.1187 22.8146 16.6476 23.0807 15.4877 23.2366C14.2693 23.4005 12.6321 23.4048 10.176 23.4048C7.71996 23.4048 6.08267 23.4005 4.86427 23.2366C3.70441 23.0807 3.2333 22.8146 2.92934 22.5107C2.6254 22.2067 2.35927 21.7356 2.20333 20.5757C2.03952 19.3573 2.0352 17.7201 2.0352 15.264V10.176C2.0352 7.71996 2.03952 6.08267 2.20333 4.86427C2.35927 3.70441 2.6254 3.2333 2.92934 2.92934C3.2333 2.6254 3.70441 2.35927 4.86427 2.20333C6.08267 2.03952 7.71996 2.0352 10.176 2.0352C10.3496 2.0352 10.5191 2.03523 10.6847 2.03531V6.94679e-05Z",
    fill: "#8566E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.08594 13.038C5.08594 12.5111 5.51306 12.084 6.03994 12.084H14.3079C14.8348 12.084 15.2619 12.5111 15.2619 13.038C15.2619 13.5648 14.8348 13.992 14.3079 13.992H6.03994C5.51306 13.992 5.08594 13.5648 5.08594 13.038Z",
    fill: "#8566E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.08594 18.1259C5.08594 17.599 5.51306 17.1719 6.03994 17.1719H10.4919C11.0188 17.1719 11.4459 17.599 11.4459 18.1259C11.4459 18.6527 11.0188 19.0799 10.4919 19.0799H6.03994C5.51306 19.0799 5.08594 18.6527 5.08594 18.1259Z",
    fill: "#8566E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7227 5.08816V0.921428C12.7227 0.581458 13.1336 0.411201 13.374 0.651595L19.7033 6.98073C19.9437 7.22112 19.7734 7.63216 19.4333 7.63216H15.2667C13.8616 7.63216 12.7227 6.49317 12.7227 5.08816Z",
    fill: "#8566E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.74e05d22893ea6336ee42325509d0abf.svg";
export { ForwardRef as ReactComponent };